<template>
	<div class="container-debug">
		<div class="container-xl">
			<div class="row">
				<div class="debug-wrapper" :class="[debugData == '' ? 'success' : 'error' ]">
					<div class="row">
						<div class="debug-top-frame col-md order-md-1">
							<div class="row">
								<div class="d-flex align-items-center">
									<h2>
										<span class="language de">Fehlerinformationen</span>
										<span class="language es">Información sobre errores</span>
										<span class="language it">Informazione errori</span>
										<span class="language en">Information on errors</span>
									</h2>
								</div>
							</div>
						</div>
						
						<div class="debug-inner col-12 order-md-3">
							<div class="debug-info">
								<div class="row">
									<template v-for="(data, index) in debugData" :key="index">
										<hr v-if="index != '0'">
										<div class="col-md-4 debug-block">
											<span class="debug-block-headline language de">
												<span>Betroffener Block: </span>
												<span class="debug-block-content">{{ data.title }}</span>
											</span>

											<span class="debug-block-headline language es">
												<span>Sección afectado por errores: </span>
												<span class="debug-block-content">{{ data.title }}</span>
											</span>

											<span class="debug-block-headline language it">
												<span>Sezione affetto da errori: </span>
												<span class="debug-block-content">{{ data.title }}</span>
											</span>

											<span class="debug-block-headline language en">
												<span>Block affected by error :</span> 
												<span class="debug-block-content">{{ data.title }}</span>
											</span>
										</div>

										<div class="col-md debug-error">
											<span class="debug-error-headline language de">
												<span>Fehler: </span>
												<span class="debug-error-content">{{ data.debugInfo }}</span>
											</span>

											<span class="debug-error-headline language es">
												<span>Error: </span>
												<span class="debug-error-content">{{ data.debugInfo }}</span>
											</span>

											<span class="debug-error-headline language it">
												<span>Errore: </span> 
												<span class="debug-error-content">{{ data.debugInfo }}</span>
											</span>

											<span class="debug-error-headline language en">
												<span>Error: </span> 
												<span class="debug-error-content">{{ data.debugInfo }}</span>
											</span>
										</div>
									</template>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="container-preview-box">
		<a class="preview-box-trigger triggered" @click="previewBoxTrigger()">
			<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 44 42" style="enable-background:new 0 0 44 42;" xml:space="preserve">
				<g id="Gruppe_4038" transform="translate(-233.001 -68)">
					<g id="Gruppe_478" transform="translate(273.333 108.333) rotate(180)">
						<g id="Ellipse_3" transform="translate(0.332 0.333)">
							<circle class="st0" cx="18" cy="19" r="20"></circle>
							<circle class="st1" cx="18" cy="19" r="19"></circle>
						</g>
						<path id="Pfad_445" class="st2" d="M14.3,8.9l10.4,10.4L14.3,29.7"></path>
					</g>
				</g>
			</svg>
		</a>

		<div class="preview-box-inner triggered">
			<div class="preview-text">
				<span>{{ this.labelPreview }}</span>
			</div>
		
			<div class="toggle-wrapper" :class="[debugData == '' ? 'success' : 'error' ]">
				<div class="toggle normal">
					<span v-show="debugData == ''">
						<span class="language de">Keine Fehler gefunden</span>
						<span class="language es">No se han encontrado errores</span>
						<span class="language it">Nessun errore trovato</span>
						<span class="language en">No errors found</span>
					</span>
		
					<span v-show="debugData != ''" class="name show-error" @click="debugToggle()">
						<span class="language de">Fehler anzeigen</span>
						<span class="language es">Mostrar errores</span>
						<span class="language it">Visualizza errori</span>
						<span class="language en">Display errors</span>
					</span>
		
					<span v-show="debugData != ''" class="name hide-error" @click="debugToggle()">
						<span class="language de">Fehler ausblenden</span>
						<span class="language es">Esconder el error</span>
						<span class="language it">Nascondere errore</span>
						<span class="language en">Hide error</span>
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	components: {
	
	},

	props: {
		debugData: {
			type: Object
		},
		labelPreview: {
			type: Array
		}
	},

	methods: {
		debugToggle() {
			const containerDebug = document.querySelector('.container-debug');
			const debugWrapper = document.querySelector('.debug-wrapper');
			const showError = document.querySelector('.show-error');
			const hideError = document.querySelector('.hide-error');

			if (containerDebug.classList.contains('active')) {
				containerDebug.classList.remove('active');
				debugWrapper.classList.remove('active');
				hideError.style.display = 'none';
				showError.style.display = 'block';
			} else {
				containerDebug.classList.add('active');
				debugWrapper.classList.add('active');
				hideError.style.display = 'block';
				showError.style.display = 'none';
			}

			let previewBoxtrigger = document.querySelector('.preview-box-trigger');
			let previewBoxInner = document.querySelector('.preview-box-inner');

			let previewBoxInnerWidth = previewBoxInner.offsetWidth;

			if (previewBoxtrigger.classList.contains('triggered') && previewBoxInner.classList.contains('triggered')) {
				previewBoxtrigger.style.left = previewBoxInnerWidth + 15 + 'px';
			}
		},

		checkLanguage() {
			var userLang = navigator.language; 
			var languageDe = document.querySelectorAll('span.de');
			var languageEs = document.querySelectorAll('span.es');
			var languageIt = document.querySelectorAll('span.it');
			var languageEn = document.querySelectorAll('span.en');

			if (userLang.includes('de')) {
				languageDe.forEach(el => el.style.display = 'block');
				languageEs.forEach(el => el.style.display = 'none');
				languageIt.forEach(el => el.style.display = 'none');
				languageEn.forEach(el => el.style.display = 'none');
			}
			else if (userLang.includes('es')) {
				languageDe.forEach(el => el.style.display = 'none');
				languageEs.forEach(el => el.style.display = 'block');
				languageIt.forEach(el => el.style.display = 'none');
				languageEn.forEach(el => el.style.display = 'none');
			}
			else if (userLang.includes('it')) {
				languageDe.forEach(el => el.style.display = 'none');
				languageEs.forEach(el => el.style.display = 'none');
				languageIt.forEach(el => el.style.display = 'block');
				languageEn.forEach(el => el.style.display = 'none');
			}
			else {
				languageDe.forEach(el => el.style.display = 'none');
				languageEs.forEach(el => el.style.display = 'none');
				languageIt.forEach(el => el.style.display = 'none');
				languageEn.forEach(el => el.style.display = 'block');
			}
		},

		previewBoxTrigger() {
			let previewBoxtrigger = document.querySelector('.preview-box-trigger');
			let previewBoxInner = document.querySelector('.preview-box-inner');
			
			let previewBoxInnerWidth = previewBoxInner.offsetWidth;

			if (previewBoxtrigger.classList.contains('triggered') && previewBoxInner.classList.contains('triggered')) {
				previewBoxtrigger.classList.remove('triggered');
				previewBoxInner.classList.remove('triggered');

				previewBoxtrigger.style.left = '20px';
				previewBoxInner.style.left = '-' + previewBoxInnerWidth + 'px';
			}
			else {
				previewBoxtrigger.classList.add('triggered');
				previewBoxInner.classList.add('triggered');

				previewBoxtrigger.style.left = previewBoxInnerWidth + 15  + 'px';
				previewBoxInner.style.left = '0';
			}
		},

		checkPreviewContainerWidth() {
			let previewBoxtrigger = document.querySelector('.preview-box-trigger');
			let previewBoxInner = document.querySelector('.preview-box-inner');

			let previewBoxInnerWidth = previewBoxInner.offsetWidth;

			if (previewBoxtrigger.classList.contains('triggered') && previewBoxInner.classList.contains('triggered')) {
				previewBoxtrigger.style.left = previewBoxInnerWidth + 15 + 'px';
			}
		}
	},

	mounted() {
		// this.debugToggle();
		this.checkLanguage();

		let previewBoxtrigger = document.querySelector('.preview-box-trigger');
		let previewBoxInner = document.querySelector('.preview-box-inner');
		
		let previewBoxInnerHeight = previewBoxInner.offsetHeight;
		let previewBoxtriggerHeight = previewBoxtrigger.offsetHeight;

		previewBoxtrigger.style.bottom = ((previewBoxInnerHeight - previewBoxtriggerHeight) / 2) + 80 + 'px';

		setTimeout(() => {
			this.checkPreviewContainerWidth();
		}, 500);
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/scss/debugmodeComponent.scss";
.st0{fill:none;stroke:var(--mainColor);stroke-width:2;stroke-miterlimit:9.9961;}
.st1{fill:none;stroke:var(--mainColor);stroke-width:2;}
.st2{fill:none;stroke:var(--mainColor);stroke-width:2;stroke-miterlimit:10;}
</style>